import request from '@/utils/request';

/**
 * 京东订单列表
 */
export function getJdOrderList(params) {
  return request({
    url: '/admin/lyp/order/jd/list',
    method: 'POST',
    data: params || {}
  });
}

/**
 * 订单状态（分组）
 */
export function getOrderStatusGrouped() {
  return request({
    url: '/admin/lyp/order/order-status/grouped',
    method: 'POST'
  });
}

/**
 * 京东订单导出
 */
export function exportJdOrder(params) {
  return request({
    url: '/admin/jd/order/export',
    method: 'GET',
    params: params
  });
}

/**
 * 京东订单详情
 */
export function getJdOrderDetail(orderNo) {
  return request({
    url: '/admin/lyp/order/jd/detail',
    method: 'POST',
    data: {
      orderNo: orderNo
    }
  });
}

/**
 * 积分/福豆使用明细
 * @param {string|number} orderNo 订单号
 */
export function getIntegralLog(orderNo) {
  return request({
    url: "/admin/order/station/getIntegralLog/".concat(orderNo),
    method: 'get'
  });
}